import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';

const ReCaptcha = ({
  cssProperties, captchaDetails,
}) => (
  <div className={cssProperties.style}>
    <ReCAPTCHA
      sitekey={captchaDetails.sitekey}
    />
  </div>

);
ReCaptcha.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  captchaDetails: PropTypes.objectOf(PropTypes.shape),
};

export default ReCaptcha;
